<template>
    <div class="btn-container">
        <v-btn
            class="btn-approve"
            small
            tile
            color="#6c98ba"
            :disabled="disabled"
            @click="changeStatus('APV')"
            :outlined="status !== 'APV'"
            width="100px"
            height="38px">
            {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.approve') }}
        </v-btn>
        <v-btn
            class="btn-reject"
            small
            tile
            color="#ff544a"
            :disabled="disabled"
            @click="changeStatus('REJ')"
            :outlined="status !== 'REJ'"
            width="100px"
            height="38px">
            {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.reject') }}
        </v-btn>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            status: ''
        }
    },
    methods: {
        changeStatus (status) {
            this.status = status
            this.$emit('input', this.status)
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-container {
    display: flex;
    justify-content: center;

    .btn-approve {
        color: white;
        border-radius: 20px 0px 0px 20px;
    }
    .btn-reject {
        color: white;
        border-radius: 0px 20px 20px 0px;
    }
}
</style>
